// Scoped CSS for the CSV bulk-import module. Prefix: .csv-

let _injected = false;
export function injectCsvStyles() {
  if (_injected) return;
  _injected = true;
  const s = document.createElement('style');
  s.id = 'csv-import-css';
  s.textContent = `
.csv-modal-body{display:flex;flex-direction:column;gap:10px}
.csv-file-input{font-size:.9rem}
.csv-hint{font-size:.74rem;color:var(--slate);line-height:1.4}
.csv-dropzone{display:flex;flex-direction:column;gap:10px;padding:16px;border:2px dashed var(--mint-border,#d4e7e3);border-radius:10px;background:#fff;cursor:pointer;transition:border-color .12s ease, background .12s ease}
.csv-dropzone-active{border-color:var(--teal,#0d9488);background:var(--mint-tint,#f0fdf9)}
.csv-dropzone-hint{font-size:.84rem;color:var(--slate);pointer-events:none}
.csv-btn-row{display:flex;justify-content:flex-end;gap:8px;margin-top:14px;flex-wrap:wrap}
.csv-preview-wrap{max-height:340px;overflow:auto;border:1px solid var(--mint-border,#d4e7e3);border-radius:8px;background:#fff}
.csv-preview-table{width:100%;border-collapse:collapse;font-size:.78rem}
.csv-preview-table th,.csv-preview-table td{padding:6px 10px;text-align:start;border-bottom:1px solid var(--mint-border,#eaf1ef);white-space:nowrap;max-width:220px;overflow:hidden;text-overflow:ellipsis}
.csv-preview-table thead th{position:sticky;top:0;background:var(--mint-tint,#f0fdf9);font-weight:600;color:var(--navy,#1a2e2b);z-index:1}
.csv-preview-table tbody tr:last-child td{border-bottom:none}
.csv-preview-table tbody tr:nth-child(even) td{background:#fafdfc}
.csv-mapping-wrap{display:flex;flex-direction:column;gap:8px;max-height:360px;overflow:auto;padding:2px}
.csv-mapping-row{display:flex;align-items:center;gap:12px;padding:10px 12px;border:1px solid var(--mint-border,#eaf1ef);border-radius:8px;background:#fff}
.csv-mapping-left{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}
.csv-mapping-header-label{font-size:.85rem;font-weight:600;color:var(--navy,#1a2e2b);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.csv-mapping-sample{font-size:.72rem;color:var(--slate);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.csv-mapping-select{flex:0 0 220px;font-size:.82rem;padding:6px 8px;border:1px solid var(--mint-border,#d4e7e3);border-radius:6px;background:#fff;color:var(--navy,#1a2e2b)}
.csv-mapping-status{font-size:.78rem;color:var(--slate);min-height:18px;margin-top:8px}
.csv-mapping-status-warn{color:var(--coral,#dc2626);font-weight:500}
.csv-summary{font-size:.85rem;font-weight:600;color:var(--navy,#1a2e2b);padding:8px 12px;background:var(--mint-tint,#f0fdf9);border-radius:8px;margin-bottom:10px}
.csv-rows-wrap{max-height:420px;overflow:auto;border:1px solid var(--mint-border,#d4e7e3);border-radius:8px;background:#fff}
.csv-rows-table{width:100%;border-collapse:collapse;font-size:.78rem}
.csv-rows-table th,.csv-rows-table td{padding:6px 8px;text-align:start;vertical-align:top;border-bottom:1px solid var(--mint-border,#eaf1ef);max-width:200px;overflow:hidden;text-overflow:ellipsis}
.csv-rows-table thead th{position:sticky;top:0;background:var(--mint-tint,#f0fdf9);font-weight:600;color:var(--navy,#1a2e2b);z-index:1}
.csv-rows-table tbody tr:last-child td{border-bottom:none}
.csv-rownum{color:var(--slate);font-variant-numeric:tabular-nums;width:32px}
.csv-row-invalid td{background:#fef2f2}
.csv-row-duplicate td{background:#fffbeb}
.csv-row-flagged td{background:#fefce8}
.csv-badge{display:inline-block;padding:2px 8px;border-radius:10px;font-size:.7rem;font-weight:600;white-space:nowrap}
.csv-badge-ok{background:#d1fae5;color:#065f46}
.csv-badge-flagged{background:#fef3c7;color:#92400e}
.csv-badge-duplicate{background:#fed7aa;color:#9a3412}
.csv-badge-invalid{background:#fecaca;color:#991b1b}
.csv-row-detail{font-size:.7rem;color:var(--slate);margin-top:3px;line-height:1.35;white-space:normal}
.csv-row-detail-err{color:#991b1b;font-weight:500}
.csv-action-select{font-size:.74rem;padding:3px 6px;border:1px solid var(--mint-border,#d4e7e3);border-radius:4px;background:#fff;color:var(--navy,#1a2e2b)}
.csv-action-excluded{font-size:.74rem;color:#991b1b;font-style:italic}
.csv-action-create{font-size:.74rem;color:#065f46}
.csv-result-panel{padding:24px 4px 8px;text-align:center}
.csv-result-icon{font-size:2.4rem;line-height:1;margin-bottom:8px}
.csv-result-title{font-size:1.05rem;font-weight:600;color:var(--navy,#1a2e2b);margin-bottom:8px}
.csv-result-summary{font-size:.88rem;color:var(--navy,#1a2e2b);margin-bottom:10px}
.csv-result-hint{font-size:.78rem;color:var(--slate);line-height:1.5}
  `;
  document.head.appendChild(s);
}
